import i18n from "../../../../constants/i18n";
import { ADMIN_RESET_PASSWORD_HEADERS } from "../../../../constants/table-custom-headers/Supervisor";
import getResetPasswordStore from "../../../../stores/supervisor-store/reset-password-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const ResetPasswordsData = withLiteObserverAndTheme(() => {
  const activeAdmins = getResetPasswordStore().activeAdmins.get();

  return (
    <Et3Table
      columns={ADMIN_RESET_PASSWORD_HEADERS}
      title={i18n.get("ADMIN")}
      rows={activeAdmins}
      shouldBeFlagged={false}
      titleKey={"ADMIN"}
    />
  );
});

export default ResetPasswordsData;
